<template>
    <div>
      <AssistantFun type="type"/>
      <AssistantInstation :type="type" v-if="type!=3"/>
    </div>
</template>

<script>
    import API from "./api";
    import AssistantFun from "./components/AssistantFun/index.vue"
    import AssistantInstation from "./components/AssistantInstation/index.vue"
    export default {
        name: "index",
        data() {
            return {
                type:1
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/ai/assistant"; //设置左侧导航2-2 active
        },
        mounted() {
         this.type= this.$route.query.type

        },
        components: {AssistantFun,AssistantInstation},
        computed: {

        },
        methods: {



        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
